import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Clock, Award, ShieldCheck, ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-32 pb-20 lg:pt-48 lg:pb-32 overflow-hidden bg-brand-gray" data-id="element-214">
      {/* Abstract Background Elements */}
      <div className="absolute top-0 right-0 -translate-y-1/4 translate-x-1/4 w-[800px] h-[800px] bg-white rounded-full opacity-50 blur-3xl pointer-events-none" data-id="element-215"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-216">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-217">
          {/* Left Column: Content */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="max-w-2xl" data-id="element-218">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-brand-navy/10 text-brand-navy text-sm font-semibold mb-6" data-id="element-219">
              <span className="w-2 h-2 rounded-full bg-brand-red" data-id="element-220"></span>
              Professional Receivables Management
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-brand-navy leading-tight mb-6" data-id="element-221">
              Recover with confidence, built on{' '}
              <span className="text-brand-red" data-id="element-222">20+ years</span> of experience.
            </h1>

            <p className="text-lg text-brand-muted mb-8 leading-relaxed max-w-xl" data-id="element-223">
              Compass Recovery Group provides full-service debt collection
              solutions. We combine industry expertise with unparalleled
              customer care to deliver results at every stage of delinquency.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-12" data-id="element-224">
              <a href="#contact" className="inline-flex justify-center items-center gap-2 bg-brand-navy hover:bg-blue-900 text-white px-8 py-3.5 rounded font-semibold transition-colors" data-id="element-225">
                Partner With Us
                <ArrowRight size={18} data-id="element-226" />
              </a>
              <Link to="/portal" className="inline-flex justify-center items-center gap-2 bg-white border-2 border-brand-red text-brand-red hover:bg-brand-red hover:text-white px-8 py-3.5 rounded font-semibold transition-colors" data-id="element-227">
                Make a Payment
              </Link>
            </div>

            {/* Trust Indicators */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 pt-8 border-t border-gray-200" data-id="element-228">
              <div className="flex items-center gap-3" data-id="element-229">
                <Clock className="text-brand-red" size={24} data-id="element-230" />
                <span className="text-sm font-semibold text-brand-dark" data-id="element-231">
                  20+ Years
                  <br data-id="element-232" />
                  Experience
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-233">
                <Award className="text-brand-red" size={24} data-id="element-234" />
                <span className="text-sm font-semibold text-brand-dark" data-id="element-235">
                  Full-Service
                  <br data-id="element-236" />
                  Collections
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-237">
                <ShieldCheck className="text-brand-red" size={24} data-id="element-238" />
                <span className="text-sm font-semibold text-brand-dark" data-id="element-239">
                  Compliance
                  <br data-id="element-240" />
                  First
                </span>
              </div>
            </div>
          </motion.div>

          {/* Right Column: Logo Visual */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="hidden lg:flex justify-center items-center relative" data-id="element-241">
            <div className="relative w-full max-w-lg" data-id="element-242">
              {/* Logo frame */}
              <div className="relative bg-white rounded-2xl shadow-xl border border-gray-100 p-12 flex items-center justify-center aspect-square" data-id="element-243">
                <img src="https://cdn.magicpatterns.com/uploads/miiyVjkag3qKFYCybFaUjL/pasted-image.jpg" alt="Compass Recovery Group, LLC logo" className="w-full h-auto object-contain" data-id="element-244" />
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}